
import './App.css';
import React from 'react';
import { Router, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import history from '../history';

import UserHome from './user/UserHome';
import UserLogin from './user/UserLogin';
import UserHeader from './user/UserHeader';
import ShowJson from './logs/ShowJson';


class App extends React.Component {
  constructor(props) {

    super(props);
    if (!this.props.auth.tokenId) {

      history.push('/login')
    }

  }

  render() {

    return (
      <div className="App">
        <Router history={history}>
          <Route path={'*'} render={() => !history.location.pathname.includes('/login') && !history.location.pathname.includes('/showJson') ? <UserHeader /> : null} />
          <Switch>
            <Route path={["/campaign", "/campaign/:term", "/log/:logType/:logTerm", "/log","/coldSmtp","/coldSmtp/:term"]} exact component={UserHome} />
            <Route path="/login" exact component={UserLogin} />
            <Route path="/showJson" exact component={ShowJson} />
          </Switch>

        </Router>
      </div>

    );

  }


}


const mapStateToProps = (state) => {
  return { auth: state.auth };
};

export default connect(mapStateToProps)(App);
